import { When } from 'react-if';
import { EffectTypeWire } from '../../core/effect/effect-type.wire';
import { EffectWire } from '../../core/effect/effect.wire';
import { DateEffectNodeItem } from './effects/date/date-effect-node-item';
import { DeadlineEffectNodeItem } from './effects/deadline/deadline-effect-node-item';
import { LastTimeEffectNodeItem } from './effects/last-time/last-time-effect-node-item';
import { ProgressEffectNodeItem } from './effects/progress/progress-effect-node-item';
import { SnoozeEffectNodeItem } from './effects/snooze/snooze-effect-node-item';

export function UnifiedEffectNodeItem({ nodeId, effect }: { nodeId: string; effect: EffectWire }) {
  return (
    <>
      <When condition={effect.type === EffectTypeWire.lastTime}>
        <LastTimeEffectNodeItem nodeId={nodeId} effect={effect} />
      </When>
      <When condition={effect.type === EffectTypeWire.progress}>
        <ProgressEffectNodeItem nodeId={nodeId} effect={effect} />
      </When>
      <When condition={effect.type === EffectTypeWire.date}>
        <DateEffectNodeItem nodeId={nodeId} effect={effect} />
      </When>
      <When condition={effect.type === EffectTypeWire.snooze}>
        <SnoozeEffectNodeItem nodeId={nodeId} effect={effect} />
      </When>
      <When condition={effect.type === EffectTypeWire.deadline}>
        <DeadlineEffectNodeItem nodeId={nodeId} effect={effect} />
      </When>
    </>
  );
}
